module.exports = __webpack_public_path__ + "img/ruasdigital.36efe84e.png";